import React, { useEffect } from "react";
import "../../assets/styles/VisitorStatisticsStyle/SalesReportStyle/SalesReportCustomers.css";
import { convertObjToArray } from "../../helper/Helper";
import axios from "../../js/Axios/Axios";
import {
  VictoryPie,
  VictoryTheme,
  VictoryLabel,
  VictoryTooltip,
} from "victory";
import { useState } from "react";
import useForceUpdate from "use-force-update";
export default function VisitorStatisticsDevices() {
  const forceUpdate = useForceUpdate();
  const [data, setData] = useState([]);
  const [witchData, setWitchData] = useState(null);
  const [dataChart, setDataChart] = useState([]);

  useEffect(() => {
    axios
      .get("/User/report")
      .then((res) => {
        console.log(res);
        let array = convertObjToArray(res.data);
        // setData(convertObjToArray(res.data));
        dataChart.map((item, index) => {
          dataChart.splice(index);
        });
        array.map((item) => {
          if (item.key !== "total_user") {
            dataChart.push({
              x: item.key,
              y: item.value,
            });

            data.push({
              key: item.key,
              value: item.value,
            });

            forceUpdate();
          }
        });
        // data.map((item, index) => {
        //   data.splice(data.indexOf(item.key === "total_user"), 1);
        //   forceUpdate();
        //   console.log(data);
        // });
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div className="sales-report-devices">
      <div className="sales-report-devices-detail">
        {data.map((item, index) => {
          return (
            <div key={index} className="sales-report-devices-detail-2">
              <p>{item.key === "old_user" && "مشتریان قدیمی"}</p>
              <p>{item.key === "guest_user" && "مشتریان مهمان"}</p>
              <p>{item.key === "new_user" && "مشریان جدید"}</p>

              <div className="sales-report-devices-detail-count">
                {item.key === "old_user" && (
                  <div className="sales-report-devices-detail-count-color"></div>
                )}
                {item.key === "guest_user" && (
                  <div className="sales-report-devices-detail-count-color-2"></div>
                )}
                {item.key === "new_user" && (
                  <div className="sales-report-devices-detail-count-color-3"></div>
                )}
                <p>{item.value} مشتری</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="sales-report-devices-pie-chart">
        {data.length != 0 && (
          <VictoryPie
            padAngle={0}
            labels={(props) =>
              props.datum.y === 0 ? "" : [`% ${props.datum.y}`]
            }
            style={{
              labels: {
                fill: "#fff",
                fontSize: 12,
                fontWeight: "500",
                fontFamily: "IRANSansFaNum",
              },
            }}
            labelComponent={<VictoryLabel dy={-0} textAnchor="middle" />}
            innerRadius={90}
            width={200}
            height={200}
            data={dataChart}
            // data={[
            //   { x: [data[0].key], y: data[0].value.percentage_visit_device },
            //   { x: [data[1].key], y: data[1].value.percentage_visit_device },
            //   { x: [data[2].key], y: data[2].value.percentage_visit_device },
            // ]}
            colorScale={["#00d3ff", "#8de2f3", "#2d99ff"]}
            events={[
              {
                target: "data",
                eventHandlers: {
                  onMouseOver: () => {
                    return [
                      {
                        mutation: (props) => {
                          console.log(props);
                          setWitchData(data[props.index]);
                        },
                      },
                    ];
                  },
                  onMouseOut: () => {
                    return [
                      {
                        mutation: () => {
                          setWitchData(null);
                        },
                      },
                    ];
                  },
                },
              },
            ]}
          />
        )}
        {witchData !== null && (
          <div className="sales-report-devices-pie-chart-label">
            <p>{witchData.key === "old_user" && "مشتریان قدیمی"}</p>
            <p>{witchData.key === "guest_user" && "مشتریان مهمان"}</p>
            <p>{witchData.key === "new_user" && "مشریان جدید"}</p>
            <p>{witchData.value}%</p>
          </div>
        )}
      </div>
    </div>
  );
}
